import { connect } from 'react-redux';
import Messages from './MessageToAgentComponent';
import {
  getData,
  getMessageSent,
  getMessages,
  isFetching,
  getError,
} from '../../../state/reducers/ApplicationReducer';
import ApplicationActions from '../../../state/actions/ApplicationActions';

const mapStateToProps = (state) => ({
  email: getData(state).applicantEmail || '',
  isSent: getMessageSent(state),
  messages: getMessages(state) || [],
  error: getError(state),
  isFetching: isFetching(state),
});

const { sendMessageRequest, sendMessageToApplicantRequest, uploadRequest } =
  ApplicationActions;

export default connect(mapStateToProps, {
  messageToOfficer: sendMessageRequest,
  messageToApplicant: sendMessageToApplicantRequest,
  upload: uploadRequest,
})(Messages);



// WEBPACK FOOTER //
// ./src/view/forms/MessageToAgent/index.js